import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { supabaseChatService, ChatMessage } from '../services/supabaseChatService';

export const useKidsChurchMessages = (
  userId: string,
  otherUserId: string
) => {
  const queryClient = useQueryClient();

  const { data, ...rest } = useQuery({
    queryKey: ['kids-chat-messages', userId, otherUserId],
    queryFn: () => supabaseChatService.getMessages(userId, otherUserId),
    enabled: !!userId && !!otherUserId,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  // realtime subscription
  useEffect(() => {
    if (!userId) return;
    const unsubscribe = supabaseChatService.subscribeToMessages(userId, (msg) => {
      if (
        (msg.sender_id === userId && msg.receiver_id === otherUserId) ||
        (msg.sender_id === otherUserId && msg.receiver_id === userId)
      ) {
        queryClient.invalidateQueries({ queryKey: ['kids-chat-messages', userId, otherUserId] });
        queryClient.invalidateQueries({ queryKey: ['kids-chat-users', userId] });
      }
    });

    return () => {
      unsubscribe();
    };
  }, [userId, otherUserId, queryClient]);

  return { data: data ?? ([] as ChatMessage[]), ...rest };
};
